export default (props = {}) => <svg width="50" height="24" viewBox="0 0 24 24"  fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M0.111256 0.986917L18.1505 11.4019L0.111255 21.8168L0.111256 0.986917Z" fill="white"/>
</svg>
